import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ConfigurationErrorBubble } from '@/components/common/ConfigurationErrorBubble';
import { ConfigurationErrorMessage } from '@/components/common/ConfigurationErrorMessage';

export const ConfigurationError = () => {
  const shortViewPort = useMediaQuery('(max-height: 768px)');
  return shortViewPort ? <ConfigurationErrorBubble /> : <ConfigurationErrorMessage />;
};
